/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppReleaseDtoListResponse } from '../models/AppReleaseDtoListResponse';
import type { AppReleaseDtoResponse } from '../models/AppReleaseDtoResponse';
import type { AppReleasePlatform } from '../models/AppReleasePlatform';
import type { AppReleaseSortBy } from '../models/AppReleaseSortBy';
import type { AppReleaseSortOrder } from '../models/AppReleaseSortOrder';
import type { AppReleaseStatus } from '../models/AppReleaseStatus';
import type { BooleanResponse } from '../models/BooleanResponse';
import type { CreateAppReleaseCommand } from '../models/CreateAppReleaseCommand';
import type { UpdateAppReleaseCommand } from '../models/UpdateAppReleaseCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AppReleaseService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param platform
     * @param status
     * @param version
     * @param sortBy
     * @param sortOrder
     * @returns AppReleaseDtoListResponse Success
     * @throws ApiError
     */
    public getApiAppReleaseAppReleases(
        platform?: AppReleasePlatform,
        status?: AppReleaseStatus,
        version?: string,
        sortBy?: AppReleaseSortBy,
        sortOrder?: AppReleaseSortOrder,
    ): CancelablePromise<AppReleaseDtoListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/AppRelease/AppReleases',
            query: {
                'Platform': platform,
                'Status': status,
                'Version': version,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns AppReleaseDtoResponse Success
     * @throws ApiError
     */
    public getApiAppReleaseAppReleaseById(
        id: string,
    ): CancelablePromise<AppReleaseDtoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/AppRelease/AppReleaseById/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AppReleaseDtoResponse Success
     * @throws ApiError
     */
    public postApiAppReleaseCreateAppRelease(
        requestBody?: CreateAppReleaseCommand,
    ): CancelablePromise<AppReleaseDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/AppRelease/CreateAppRelease',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AppReleaseDtoResponse Success
     * @throws ApiError
     */
    public putApiAppReleaseUpdateAppRelease(
        requestBody?: UpdateAppReleaseCommand,
    ): CancelablePromise<AppReleaseDtoResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/AppRelease/UpdateAppRelease',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns BooleanResponse Success
     * @throws ApiError
     */
    public deleteApiAppReleaseDeleteAppRelease(
        id: string,
    ): CancelablePromise<BooleanResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/AppRelease/DeleteAppRelease/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
